<div class="avs-dashboard-title">
    <h6>Batteriespannung</h6>
</div>
<div class="avs-dashboard-canvas">
    <canvas id="canvasBattery">{{chart}}</canvas>
</div>
